import { z } from 'zod/v4';

export const EMAIL_PROCESS_STATUSES = ['processed', 'unprocessed'] as const;
export const EMAIL_READ_STATUSES = ['read', 'unread'] as const;
export const MAIL_STATUSES = [...EMAIL_PROCESS_STATUSES, ...EMAIL_READ_STATUSES] as const;

export type EmailProcessStatus = (typeof EMAIL_PROCESS_STATUSES)[number];
export type EmailReadStatus = (typeof EMAIL_READ_STATUSES)[number];
export type MailStatus = (typeof MAIL_STATUSES)[number];

export const EmailProcessStatusSchema = z.enum([...EMAIL_PROCESS_STATUSES]);
export const EmailReadStatusSchema = z.enum([...EMAIL_READ_STATUSES]);
export const MailStatusSchema = z.enum([...MAIL_STATUSES]);
